import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, Observable, Observer } from "rxjs";
import { Task } from "../../model/task";
import { Messages } from "../../model/messages";
import { TaskService } from "../../services/task.service";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../services/navigation.helper";
import { Ticket } from "../../model/ticket";
import { Navigation } from "../../model/navigation";
import { ActionButtonSubmit } from "../../model/action-button-submit";
import { SingleChoice } from "../../model/singlechoice";
import { UsersService } from "../../services/users.service";
import { StatusService } from "../../services/status.service";
import { TicketService } from "../../services/ticket.service";
@Component({
  selector: "task-details",

  templateUrl: "task-details.component.html",
  styleUrl: "task-details.component.css",
})
export class TaskDetailsComponent implements OnInit {
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  task = new BehaviorSubject<Task>(
    new Task(0, 0, "", "", 0, 0, new Date(), "", "", 0)
  );
  editMode: boolean = false;
  taskForm: FormGroup;
  taskTitle: string = "taskDetails.title.task.details";
  @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
  @Input() currentTicket: Observable<Ticket>;
  ticket: Ticket | null = null;
  @Input() selectedTask: boolean | null = null;

  executorLabeler = new BehaviorSubject<string>("-");
  statusIdLabeler = new BehaviorSubject<string>("-");
  currentId: number | null;
  tasks: BehaviorSubject<Task[]> = new BehaviorSubject<Task[]>([]);
  completionUrl = new BehaviorSubject<string>("");
  isLoading: boolean = false;
  stateGuard: boolean;
  taskBackup: Ticket | null = null;
  constructor(
    private ticketService: TicketService,
    private taskService: TaskService,
    private auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper,
    private users: UsersService,
    private statuses: StatusService
  ) {}

  ngOnInit(): void {
    this.taskService._currentTasks.subscribe((task) => {
      this.tasks.next(task);
    });
    this.initializeForm();
    const restoredState = this.taskService.restoreFormState();

    this.taskForm.valueChanges.subscribe((formValue) => {
      if (this.stateGuard) {
      } else if (this.editMode) {
        this.stateGuard = true;

        this.taskService.setFormState(formValue);
        this.stateGuard = false;
      }
    });
    this.taskService.formState.subscribe((restoredState) => {
      if (this.stateGuard) {
      } else if (this.editMode) {
        this.restoreFormValues(restoredState);
      }
    });
    this.task.subscribe((task) => {
      this.statusIdLabeler.next(this.statusLabel);
      this.executorLabeler.next(this.executorLabel);
    });

    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentId = ticket.id;
        this.ticket = ticket;
      });
    }
    if (Navigation.NEW.toString() === this.nav.currentId) {
      this.editMode = true;
      this.taskForm.reset();
      this.taskTitle = "taskDetails.title.new.task";
    }

    this.taskService.selectedTaskObservable.subscribe((selectedTask) => {
      if (selectedTask) {
        try {
          const oldGuard = this.stateGuard;
          this.stateGuard = true;
          const restored = this.taskService.restoreFormState();

          if (restored) {
            if (restored.title) {
              selectedTask.title = restored.title;
            }
            if (restored.remark) {
              selectedTask.remark = restored.remark;
            }
            if (restored.status) {
              selectedTask.status = restored.status;
            }
            if (restored.task_type) {
              selectedTask.task_type = restored.task_type;
            }
            if (restored.end_date) {
              selectedTask.end_date = restored.end_date;
            }
            if (restored.details) {
              selectedTask.details = restored.details;
            }
            if (restored.executorId) {
              selectedTask.executorId = restored.executorId;
            }
          }
          this.stateGuard = oldGuard;
        } catch (e: any) {}

        this.populateForm(selectedTask);
        this.completionUrl.next(
          "tickets/" + this.currentId + "/fragmentedit/task/" + selectedTask.id
        );
      }
    });

    if (
      !(
        this.taskService.currentTask &&
        this.taskService.currentTask.id &&
        this.taskService.currentTask.id > 0
      )
    ) {
      this.taskService.selectFromRouter();
    }
    this.nav.fragmentId.subscribe((id) => {
      if (
        this.nav.currentFragmentTopic === "task" &&
        (id === "-9" || Number(id) > 0)
      ) {
        const fragmentId = Number(id);

        if (fragmentId > 0) {
          const action = this.nav.currentAction;

          if (action === "fragment") {
            this.editMode = false;
          } else if (
            action === "fragmentedit" &&
            fragmentId === Navigation.NEW
          ) {
            this.editMode = true;
          } else if (action === "fragmentedit") {
            this.editMode = true;
          }
        }
      }
    });
  }
  restoreFormValues(restoredState: Partial<Task>) {
    if (Object.keys(restoredState).length > 0) {
      this.populateForm(restoredState as Task);
    }
  }
  private initializeForm(): void {
    this.taskForm = this.fb.group({
      title: "",
      remark: "",
      status: 0,
      task_type: 0,
      end_date: null,
      details: "",
      executorId: 0,
    });
  }

  private populateForm(task: Task): void {
    this.task.next(task);
    this.taskForm.patchValue({
      title: task.title,
      remark: task.remark,
      status: task.status,
      task_type: task.task_type,
      end_date: task.end_date,
      details: task.details,
      executorId: task.executorId,
    });

    this.editMode = task.id === Navigation.NEW;
    this.taskTitle = this.editMode
      ? "taskDetails.title.new.task"
      : "taskDetails.title.task.details";
  }

  toggleEditMode() {
    if (this.editMode) {
      this.editMode = false;
      this.taskService.clearFormStateBackup();
      this.task.next(Task.EMPTY);
      this.taskForm.reset();
      this.taskTitle = "taskDetails.title";
    } else {
      this.router.navigate([
        "tickets/" + this.currentId + "/fragmentedit/task/" + this.taskId,
      ]);
      this.editMode = true;
    }
  }

  saveTask(action: ActionButtonSubmit): void {
    this.isLoading = true;
    if (this.taskForm.valid) {
      const token = this.auth.token;
      const id = this.task.value.id;
      const ticketId = this.currentId;

      if (ticketId == null) {
        return;
      }

      const executorName = this.executorLabel;
      const updatedTask = new Task(
        id && id >= 1 ? id : Navigation.NEW,
        ticketId,
        this.taskForm.value.title || "",
        this.taskForm.value.remark || "",
        this.taskForm.value.status || 0,
        this.taskForm.value.task_type || 0,
        this.taskForm.value.end_date || null,
        this.taskForm.value.details || "",
        executorName || "",
        this.taskForm.value.executorId || 0
      );

      if (updatedTask.id === null || updatedTask.id < 1) {
        this.taskService
          .createTask(token, ticketId, updatedTask)
          .subscribe((messages) => {
            this.receiveTask(messages, action, ticketId, token);
          });
      } else {
        const task = this.taskService.currentTask;
        this.taskService
          .updateTask(token, ticketId, updatedTask)
          .subscribe((messages) => {
            this.receiveTask(messages, action, ticketId, token);
          });
      }
    }
  }

  receiveTask(
    messages: Messages,
    action: ActionButtonSubmit,
    ticketId: number,
    token: string
  ) {
    this.isLoading = false;
    this.messages.next(messages);
    if (messages.hasAnyMessages) {
      action.result(false);
    } else {
      action.result(true);
      this.taskService.clearFormStateBackup();
      this.ticketService
        .getTicketWithParts(token, ticketId, this.ticket || undefined)
        .subscribe((messages) => {
          this.messages.next(messages);
        });
      const task = this.taskService.currentTask;
      const taskId: number = task.id;
      const url = "tickets/" + this.currentId + "/fragment/task/" + taskId;
      this.router.navigate([url]);
    }
  }

  relaySingleChoice(choice: SingleChoice) {
    this.taskService.setFormState(this.taskForm.value);
    this.nav.startChoice(choice);
  }

  deleteTask(): void {
    const token = this.auth.token;
    const taskId = this.task.value.id;
    const ticketId = this.task.value.ticketId;

    if (taskId != null && ticketId != null) {
      this.taskService.deleteTask(token, ticketId, taskId).subscribe(
        (response) => {
          this.updateTaskList(token, ticketId);
          this.task.next(Task.EMPTY);
        },
        (error) => {
          this.messages.next(Messages.from({ task: ["task.delete.failed"] }));
        }
      );
    }
  }

  private updateTaskList(token: string, ticketId: number): void {
    this.taskService.getTasks(token, ticketId).subscribe((messages) => {
      this.messages.next(messages);
    });
  }
  get statusIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onStatusChoice(id);
      },
    };
  }
  onStatusChoice(status: number): void {
    const current = this.task.value;
    current.status = status;
    this.task.next(current);

    this.populateForm(this.task.value);
    this.taskService.restoreFormState();
    this.taskForm.patchValue({
      status: status,
    });
    this.taskService.setFormState(this.taskForm.value);
    this.editMode = true;
  }
  get executorIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onExecutorChoice(id);
      },
    };
  }
  onExecutorChoice(executor: number): void {
    const current = this.task.value;
    current.executorId = executor;
    this.task.next(current);

    this.populateForm(this.task.value);
    this.taskService.restoreFormState();
    this.taskForm.patchValue({
      executorId: executor,
    });
    this.taskService.setFormState(this.taskForm.value);
    this.editMode = true;
  }

  get taskId(): number {
    const task = this.task.value;
    return task && task.id ? task.id : Navigation.NEW;
  }
  get statusId(): number {
    const task = this.task.value;
    return task && task.status ? task.status : -1;
  }
  get statusLabel(): string {
    const id = this.statusId;

    let label = "-";
    if (id > 0) {
      label = this.statuses.labelForId(id);
    }

    return label;
  }
  get executorId(): number {
    const task = this.task.value;
    return task && task.executorId ? task.executorId : -1;
  }

  get executorLabel(): string {
    const id = this.executorId;

    let label = "-";
    if (id > 0) {
      label = this.users.labelForId(id);
    }

    return label;
  }

  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
}
